var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 2,
    viewBox: "0 0 124 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M0.5 1H124",
    stroke: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorLine);
export default __webpack_public_path__ + "static/media/Vector_line.482964dfbf1eb98eff0f7efccb11e057.svg";
export { ForwardRef as ReactComponent };